module.exports = __webpack_public_path__ + "media/images/parallax/illustration-welcome-foreground-b0f3e1cb2189f572355a4d982b39f6c6.svg";